var exports = {};
const isHyper = typeof process !== "undefined" && process.env.TERM_PROGRAM === "Hyper";
const isWindows = typeof process !== "undefined" && process.platform === "win32";
const isLinux = typeof process !== "undefined" && process.platform === "linux";
const common = {
  ballotDisabled: "\u2612",
  ballotOff: "\u2610",
  ballotOn: "\u2611",
  bullet: "\u2022",
  bulletWhite: "\u25E6",
  fullBlock: "\u2588",
  heart: "\u2764",
  identicalTo: "\u2261",
  line: "\u2500",
  mark: "\u203B",
  middot: "\xB7",
  minus: "\uFF0D",
  multiplication: "\xD7",
  obelus: "\xF7",
  pencilDownRight: "\u270E",
  pencilRight: "\u270F",
  pencilUpRight: "\u2710",
  percent: "%",
  pilcrow2: "\u2761",
  pilcrow: "\xB6",
  plusMinus: "\xB1",
  question: "?",
  section: "\xA7",
  starsOff: "\u2606",
  starsOn: "\u2605",
  upDownArrow: "\u2195"
};
const windows = Object.assign({}, common, {
  check: "\u221A",
  cross: "\xD7",
  ellipsisLarge: "...",
  ellipsis: "...",
  info: "i",
  questionSmall: "?",
  pointer: ">",
  pointerSmall: "\xBB",
  radioOff: "( )",
  radioOn: "(*)",
  warning: "\u203C"
});
const other = Object.assign({}, common, {
  ballotCross: "\u2718",
  check: "\u2714",
  cross: "\u2716",
  ellipsisLarge: "\u22EF",
  ellipsis: "\u2026",
  info: "\u2139",
  questionFull: "\uFF1F",
  questionSmall: "\uFE56",
  pointer: isLinux ? "\u25B8" : "\u276F",
  pointerSmall: isLinux ? "\u2023" : "\u203A",
  radioOff: "\u25EF",
  radioOn: "\u25C9",
  warning: "\u26A0"
});
exports = isWindows && !isHyper ? windows : other;
Reflect.defineProperty(exports, "common", {
  enumerable: false,
  value: common
});
Reflect.defineProperty(exports, "windows", {
  enumerable: false,
  value: windows
});
Reflect.defineProperty(exports, "other", {
  enumerable: false,
  value: other
});
export default exports;